import { UpdateTeamEntityRequest } from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const updateTeamEntity = (
  req: Partial<UpdateTeamEntityRequest>
): Promise<void> =>
  request({
    url: '/service/userv2service/UpdateTeamEntity',
    body: req,
  }).then((r) => r.body);
